import React from "react";
import { datadogRum } from "@datadog/browser-rum";
import { Button, VerticalList } from "mesh-component-library";
import { LocationCard } from "../LocationCard";
import { GoogleDestinationWithPlaceId } from "../../../../types";
import { GenericNoNearbyDestinationError, NoNearbyPepDestinationError } from "./NoDestinationError";
import { dialCustomerServicePhone, sanitizePhoneForTelLink } from "../../../../utilities/PhoneUtils";
import { ListWrapper } from "./ListView.styles";

export type ListViewProps = {
  customerServicePhoneNumber: string;
  destinations: GoogleDestinationWithPlaceId[];
  isPep: boolean;
  nearbyDestinationError: boolean;
  onClick: (payload) => void;
  partnerCode: string;
  placesCount: number;
  service: google.maps.places.PlacesService;
  towToDestinations?: any[];
};

export const ListView = ({
  customerServicePhoneNumber,
  destinations,
  isPep,
  nearbyDestinationError,
  onClick,
  partnerCode,
  placesCount,
  service,
  towToDestinations = [],
}: ListViewProps) => {
  const noDestinationError = nearbyDestinationError;
  const isPepNoDestinationError = nearbyDestinationError && isPep;
  const showLoadMoreButton = placesCount > destinations.length;

  const handleCallCustomerServiceClick = () => {
    datadogRum.addAction("[ListView] User clicked call customer service");
    const sanitizedCustomerServicePhoneNumber = sanitizePhoneForTelLink(customerServicePhoneNumber);
    if (sanitizedCustomerServicePhoneNumber) {
      window.location.href = `tel:${sanitizedCustomerServicePhoneNumber}`;
    } else {
      dialCustomerServicePhone(localStorage.getItem("tollFreeNumber"), "ListView");
    }
  };

  const getItems = () => {
    return destinations.map((destination) => (
      <LocationCard key={destination.place_id} destination={destination} service={service} />
    ));
  };

  const handleClick = () => {
    onClick({
      service,
      destinations,
    });
  };

  if (isPepNoDestinationError) {
    return <NoNearbyPepDestinationError onClick={handleCallCustomerServiceClick} />;
  }

  if (noDestinationError) {
    return <GenericNoNearbyDestinationError onClick={handleCallCustomerServiceClick} />;
  }

  return (
    <>
      <ListWrapper>
        <VerticalList divider="none" spacing="2" items={getItems()} />
      </ListWrapper>
      {showLoadMoreButton && (
        <Button style={{ marginTop: "8px" }} onClick={handleClick} data-testid="listView-loadMoreButton">
          Load More
        </Button>
      )}
    </>
  );
};
